import { assetsPath } from "../../utils";

const path = assetsPath();

export default [
  {
    x: 560,
    y: 290,
    width: 40,
    path: `${path}/images/partner-logo/logo-angsana-oceanview-residences.svg`,
  },
  {
    x: 665,
    y: 155,
    width: 80,
    path: `${path}/images/partner-logo/logo-angsana-beachfront-residences.svg`,
  },
  {
    x: 1065,
    y: 317,
    width: 80,
    path: `${path}/images/partner-logo/logo-banyantree-residences-phuket.svg`,
  },
  {
    x: 1115,
    y: 213,
    width: 89,
    path: `${path}/images/partner-logo/logo-banyantree-grand-residences.svg`,
  },
  {
    x: 360,
    y: 230,
    width: 80,
    path: `${path}/images/partner-logo/cassia-phuket.svg`,
  },
  {
    x: 320,
    y: 300,
    width: 70,
    path: `${path}/images/partner-logo/cassia-residences-phuket.svg`,
  },
  {
    x: 200,
    y: 370,
    width: 110,
    path: `${path}/images/partner-logo/dhawa-phuket.svg`,
  },
  {
    x: 935,
    y: 545,
    width: 80,
    key: "laguna-village-residences",
    path: `${path}/images/partner-logo/laguna-village-residences.svg`,
  },
  {
    x: 510,
    y: 460,
    width: 80,
    path: `${path}/images/partner-logo/laguna-park.svg`,
  },
  {
    x: 1205,
    y: 620,
    width: 100,
    path: `${path}/images/partner-logo/loft.svg`,
  },
  {
    x: 1360,
    y: 810,
    width: 90,
    height: 90,
    key: "laguna-park2",
    path: `${path}/images/partner-logo/lagunaPark2.svg`,
  },
  {
    x: 475,
    y: 415,
    width: 40,
    key: "phuket-skypark",
    path: `${path}/images/partner-logo/phuket-skypark.svg`,
  },
];



// WEBPACK FOOTER //
// ./src/containers/ProjectMap/common-logos.js